import React from 'react';
import cn from 'clsx';
import styles from './styles.module.scss';
import { textToId } from '@utils/automation-test-helpers';

export interface GridMenuButtonItem {
    label: string;
    isActive: boolean;
    isDisabled?: boolean;
    isHidden?: boolean;
    icon?: React.ReactNode;
}

interface GridMenuButtonProps<T extends GridMenuButtonItem> {
    item: T;
    onClick: (item: T) => void;
    rightArrow?: boolean;
}

const GridMenuButton = <T extends GridMenuButtonItem>({ item, onClick, rightArrow }: GridMenuButtonProps<T>) => (
    <button
        type="button"
        hidden={item.isHidden}
        className={cn('k-d-flex k-align-items-center k-border-0 k-w-full k-px-2 k-py-0', styles.menuItem, {
            [styles.active]: item.isActive,
            'k-disabled': item?.isDisabled,
        })}
        onClick={() => {
            if (item?.isDisabled) return;

            onClick(item);
        }}
        data-testid={`menu-item-${textToId(item.label)}`}
    >
        {!!item.icon && (
            <div className={cn('k-w-4.5 k-mr-2 k-d-flex k-justify-content-center', styles.iconHovered)}>
                {item.icon}
            </div>
        )}
        <span className={styles.text}>{item.label}</span>
        {!!rightArrow && (
            <span
                className={cn('k-ml-auto k-mr-0.5 k-icon k-font-icon', {
                    'k-i-caret-alt-down': item.isActive,
                    'k-i-caret-alt-right': !item.isActive,
                })}
            />
        )}
    </button>
);

export default GridMenuButton;
